<template>
    <div class="num-box" v-show="flag === true">
        人數：<span :class="spanClass">{{num}}</span>
    </div>
</template>

<script setup>
    import {getCurrentInstance, ref, onMounted, onUnmounted} from 'vue'
    import userApi from "@/request/userApi";

    let { proxy } = getCurrentInstance();
    const Axios = proxy.$Axios;

    let settingObj = null
    let timeHandle = null

    const num = ref(0)
    const flag = ref(false)
    const spanClass = ref("")

    function calcPersonNum(x, maxNum, addNum, minNum) {
        x = x / 3600000
        maxNum = maxNum - minNum

        let hours = x % 24
        let days = Math.floor(x / 24)
        x -= days * 10

        if (hours <= 8){
            x -= hours
        }else if (hours > 8 && hours <= 22){
            x -= 8
        }else if (hours < 24){
            x -= 8
            x -= hours % 22
        }

        return Math.floor(Number(maxNum * (1 - Math.pow(Math.E, (x/addNum) * -1))) + Number(minNum))
    }

    function calcResult(){
        if (null != settingObj){
            let obj = settingObj

            if (Number(obj.o) !== -1){
                flag.value = false
            }else{
                flag.value = true

                const currTime = new Date().getTime()
                let calcNum = 0

                if (currTime > obj.e){
                    calcNum = calcPersonNum(obj.e - obj.s, Number(obj.m), Number(obj.a), Number(obj.i))
                }else if(currTime < obj.s){
                    calcNum = obj.i
                }else{
                    calcNum = calcPersonNum(currTime - obj.s, Number(obj.m), Number(obj.a), Number(obj.i))
                }

                if (calcNum > num.value){
                    if (spanClass.value === "" || spanClass.value === "amimation-span-1"){
                        spanClass.value = "amimation-span-2"
                    }else{
                        spanClass.value = "amimation-span-1"
                    }
                }

                num.value = calcNum
            }

        }else{
            num.value = 0
        }
    }

    async function getSettingObj(){
        const request = userApi.getTool1Setting
        const params = request.getParams()

        request.send(params, (res) => {
            if (res.code == 200){
                const str = res.detail

                if(null != str){
                    settingObj = JSON.parse(str)

                    timeHandle = setInterval(() =>{
                        calcResult()
                    }, 5000)
                }
            }
        })

    }

    onMounted(() => {
        getSettingObj()
    })

    onUnmounted(() => {
        clearInterval(timeHandle)
    })
</script>

<style scoped>
    .num-box {
        position: absolute;
        /*width: 100%;*/
        /*height: 100%;*/
        /*background: #00000050;*/
        display: inline-block;
        left: 2px;
        top: 2px;
        /*align-items: center;*/
        /*justify-content: center;*/
        font-size: 12px;
    }
    /*#2c3e50*/
    .amimation-span-1 {
        font-weight: 600;
        animation: animate-num-1 5s ease;
    }

    .amimation-span-2 {
        font-weight: 600;
        animation: animate-num-2 5s ease;
    }

    @keyframes animate-num-1{
        0%{
            color: #2c3e50;
        }
        50% {
            color: #ff0000;
        }
        100%{
            color: #2c3e50;
        }
    }

    @keyframes animate-num-2{
        0%{
            color: #2c3e50;
        }
        50% {
            color: #ff0000;
        }
        100%{
            color: #2c3e50;
        }
    }
</style>